(function ($, undefined) {

    "use strict";

    /**
     * jQuery-ui plugin for creating a catalog filter widget.
     *
     *     @example
     *     $('#catalog ul').catalogSearch({
     *         url: "/catalog/ajax",
     *         template: $('#catalogProductTemplate').html()
     *     });
     *
     * @class jQuery.catalogFilter
     */
    $.widget("ofcs.searchForm", {

        widgetEventPrefix: 'search',

        widgetBaseClass: 'ofcs-search-form',

        _previousTerm: '',

        options: {
            term: '',
            placeholder: 'Type to search',
            abortTemplate: '<a class="abort"><i class="icon-remove-sign"></i></a>',
            delay: 10
        },

        _create: function () {
            var self       = this,
                options    = this.options,
                element    = this.element,
                inputElem  = this.inputElement = element.find(':text'),
                submitElem = this.submitElement = element.find(':submit'),
                abortElem  = this.abortElement = $(options.abortTemplate);

            element.addClass(this.widgetBaseClass);

            element.on('submit' + this.eventNamespace, function(event) {
                event.preventDefault();
                event.stopPropagation();
            });

            element.on("keyup" + this.eventNamespace + " keydown" + this.eventNamespace, function(event) {
                event.stopPropagation();
            });

            inputElem.attr({
                placeholder: options.placeholder,
                autocomplete: "off"
            });

            inputElem.on("keyup" + this.eventNamespace, $.proxy(this._onInputKeyUp, this));

            submitElem.hide();

            abortElem.insertAfter(inputElem);

            abortElem.on('click', function(event) {
                self._setOption('term', '');
                event.preventDefault();
            });

            if (options.term) {
                inputElem.val(options.term);
                abortElem.show();
            }
        },

        _onInputKeyUp: function(event) {
            var self      = this,
                newTerm   = this.inputElement.val().trim(),
                abortElem = this.abortElement;

            abortElem.toggle(!!newTerm);

            if (this._inputHasChanged()) {
                clearTimeout(this._inputTimeout);
                this._previousTerm = newTerm;
                this._inputTimeout = setTimeout(function() {
                    self._updateTerm(newTerm, event);
                }, this.options.delay);
            }
        },

        _inputHasChanged: function() {
            return this.inputElement.val().trim() !== this._previousTerm;
        },

        _updateTerm: function(newTerm, event, silent) {
            this.options.term  = newTerm;
            this._previousTerm = newTerm;

            if (!silent) {
                this._trigger('search', event, {term: newTerm});
            }
        },

        _updateTermAndInput: function(newTerm, event, silent) {
            var inputElem = this.inputElement,
                abortElem = this.abortElement;

            this._updateTerm(newTerm, event, silent);

            inputElem.val(newTerm);
            abortElem.toggle(!!inputElem.val());
        },

        _setOption: function(key, value) {
            $.Widget.prototype._setOption.apply( this, arguments );

            switch(key) {
                case "term":
                    this._updateTermAndInput(value, undefined, false);
                    break;
            }
        },

        _destroy: function() {

            var element    = this.element,
                inputElem = this.inputElement,
                submitElem = this.submitElement,
                abortElem  = this.abortElement;

            element.off(this.eventNamespace)
                .removeClass(this.widgetBaseClass);

            inputElem.off(this.eventNamespace)
                     .removeAttr('autocomplete')
                     .removeAttr('placeholder');

            submitElem.show();

            abortElem.remove();
        }

    });

}(jQuery));
